module.exports = __webpack_public_path__ + "img/1574101061.24b6aed0.jpg";